export function forwarding(state = null, action) {
    switch (action.type) {
		case 'UPDATE_FORWARDING_CONTENT':
			let newState = action.content ? Object.assign({}, action.content) : null;
            return newState;
        default:
            return state;
    }
};